"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MdInfoOutline = require("@react-icons/all-files/md/MdInfoOutline");

var _MdVideocam = require("@react-icons/all-files/md/MdVideocam");

var _nanoid = require("nanoid");

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _DictionaryTerms = require("./DictionaryTerms.constants");

var _DictionaryTerms2 = require("./DictionaryTerms.styles");

var DictionaryTerm = function DictionaryTerm(_ref) {
  var liveClickerVideoTag = _ref.liveClickerVideoTag,
      term = _ref.term,
      baseApiUrl = _ref.baseApiUrl;
  var uniqueId = (0, _nanoid.nanoid)();
  var _modalSize = _DictionaryTerms.modalSize[liveClickerVideoTag ? 'video' : 'default'],
      width = _modalSize.width,
      height = _modalSize.height;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2.StyledDictionaryTerm, {
    className: "ac-dictionary-term",
    "data-id": uniqueId,
    "data-videoname": liveClickerVideoTag,
    "data-width": width,
    "data-height": height,
    href: "".concat(baseApiUrl).concat(_DictionaryTerms.endpoint, "?term=").concat(term)
  }, /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2.StyledDictionaryTermContainer, null, !!liveClickerVideoTag && /*#__PURE__*/_react["default"].createElement(_MdVideocam.MdVideocam, null), !liveClickerVideoTag && /*#__PURE__*/_react["default"].createElement(_MdInfoOutline.MdInfoOutline, null), term)));
};

DictionaryTerm.defaultProps = {
  liveClickerVideoTag: undefined,
  baseApiUrl: ''
};
DictionaryTerm.propTypes = {
  term: _propTypes.string.isRequired,
  liveClickerVideoTag: _propTypes.string,
  baseApiUrl: _propTypes.string
};
DictionaryTerm.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DictionaryTerm",
  "props": {
    "liveClickerVideoTag": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "baseApiUrl": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "term": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = DictionaryTerm;
exports["default"] = _default;